import $axios from '@/axios-instance.js'

export const licenseService = {
  getListData,
  getById,
  create,
  update,
  delete: _delete
}

function getListData (filter, page) {
  return $axios.get(`${process.env.ROOT_API}/licenses`, {
    params: Object.assign({ currentPage: page }, filter)
  })
    .then(response => {
      return response.data
    })
}

function getById (id) {
  return $axios.get(`${process.env.ROOT_API}/licenses/${id}`).then(response => {
    return response.data
  })
}

function create (license) {
  return $axios.post(`${process.env.ROOT_API}/licenses`, license).then(response => {
    return response.data
  })
}

function update (license) {
  return $axios.put(`${process.env.ROOT_API}/licenses/${license.licenseId}`, license).then(response => {
    return response.data
  })
}

function _delete (id) {
  return $axios.delete(`${process.env.ROOT_API}/licenses/${id}`).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/license.service.js